module.exports = __webpack_public_path__ + "static/media/tream-team.bd157d70.jpg";